import colors from './colors';
import bold from '../fonts/Toyota-Bold/Toyota-Bold';

const toyotaTheme = {
  toyota: {
    Fonts: {
      bold,
    },
    ...colors,
  },
};

export default toyotaTheme;
